
import {
  UsuarioPerfil,
  UsuarioStatus,
  Funcionario
} from '../index';


export class Pessoa {
  "Codigo";
  "CodigoPerfil";
  "CodigoStatus";
  "NomeCompleto";
  "Foto";
  "RE";
  "CPF";
  "Telefone";
  "Email";
  "Cadastro";
  "UsuarioEmissor";
  "Usuario";
  "DataAlteracao";
  "ForcarAlteracaoSenha";
  "EmailConfirmado";
  "Matricula";
  "PersonalNumber";
  "Vendor";
  UsuarioPerfil;
  UsuarioStatus;
  Funcionario;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Pessoa`.
   */
  static getModelName() {
    return "Pessoa";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Pessoa for dynamic purposes.
  **/
  static factory(data) {
    return new Pessoa(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'Pessoa',
      plural: 'Pessoas',
      path: 'Pessoas',
      properties: {
        "Codigo": {
          name: 'Codigo',
          type: 'number'
        },
        "CodigoPerfil": {
          name: 'CodigoPerfil',
          type: 'number'
        },
        "CodigoStatus": {
          name: 'CodigoStatus',
          type: 'number'
        },
        "NomeCompleto": {
          name: 'NomeCompleto',
          type: 'string'
        },
        "Foto": {
          name: 'Foto',
          type: 'string'
        },
        "RE": {
          name: 'RE',
          type: 'string'
        },
        "CPF": {
          name: 'CPF',
          type: 'string'
        },
        "Telefone": {
          name: 'Telefone',
          type: 'string'
        },
        "Email": {
          name: 'Email',
          type: 'string'
        },
        "Cadastro": {
          name: 'Cadastro',
          type: 'Date'
        },
        "UsuarioEmissor": {
          name: 'UsuarioEmissor',
          type: 'number'
        },
        "Usuario": {
          name: 'Usuario',
          type: 'string'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "ForcarAlteracaoSenha": {
          name: 'ForcarAlteracaoSenha',
          type: 'boolean',
          default: true
        },
        "EmailConfirmado": {
          name: 'EmailConfirmado',
          type: 'boolean',
          default: false
        },
        "Matricula": {
          name: 'Matricula',
          type: 'string'
        },
        "PersonalNumber": {
          name: 'PersonalNumber',
          type: 'string'
        },
        "Vendor": {
          name: 'Vendor',
          type: 'string'
        },
      },
      relations: {
        UsuarioPerfil: {
          name: 'UsuarioPerfil',
          type: 'UsuarioPerfil',
          model: 'UsuarioPerfil'
        },
        UsuarioStatus: {
          name: 'UsuarioStatus',
          type: 'UsuarioStatus',
          model: 'UsuarioStatus'
        },
        Funcionario: {
          name: 'Funcionario',
          type: 'Funcionario',
          model: 'Funcionario'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Pessoa.js